<template>
  <v-btn
    :class="{ 'show-btn-on-hover': hover }"
    :color="color"
    icon
    small
    @click="$emit('handler')"
  >
    <v-icon small :class="{ 'show-btn-on-hover': hover }" :color="color">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "rgba(255, 255, 255, 0)",
    },
    icon: {
      type: String,
      default: "edit",
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
